export function isValidString(str: any): Boolean {
  return isValid(str) && str.length > 0
}

export function isValid(obj: any): Boolean {
  return obj !== undefined && obj !== null;
}